/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import Feathers from "@feathersjs/feathers";

import { CustomError } from "@Internal/Models";
import { Autobind } from "@Internal/Utils";

import Revenue from "App/Models/Revenue";

import { ProcessException } from "./Base";

/* Fetches the home dashboard snapshot. The backend returns a plain nested object (exempt from the
   generic serializer), so we read it straight from the Feathers `find` response rather than going
   through BaseService's record/pagination deserialization. */
export default class RevenueService {
    private service: Feathers.Service<any>;

    constructor( service: Feathers.Service<any> ) {
        this.service = service;
    }

    @Autobind
    async Snapshot(
        params?: { From?: string; To?: string; Granularity?: string; Compare?: string }
    ): Promise<[ Revenue | undefined, CustomError | undefined ]> {
        try {
            const query: { [ key: string ]: string } = {};

            if( params !== undefined ) {
                if( params.From !== undefined )
                    query.From = params.From;

                if( params.To !== undefined )
                    query.To = params.To;

                if( params.Granularity !== undefined )
                    query.Granularity = params.Granularity;

                if( params.Compare !== undefined )
                    query.Compare = params.Compare;
            }

            const result = await this.service.find( { query } );

            /* The snapshot always carries MonthlyRevenue; anything else is an error payload. */
            if( result === undefined || result.MonthlyRevenue === undefined ) {
                const id = ( result !== undefined && result.Id !== undefined )
                    ? result.Id
                    : "Revenue.Snapshot";

                const message = ( result !== undefined && result.Message !== undefined )
                    ? result.Message
                    : "Unexpected revenue response";

                return [ undefined, new CustomError( id, message ) ];
            }

            return [ result as Revenue, undefined ];

        } catch( error ) {
            return [ undefined, await ProcessException( error ) ];
        }
    }
}
